import React from 'react'
import AddEnergyBreadCrumb from './AddEnergyBreadCrumb';
import AddRenewableEnergy from './AddRenewableEnergy';
function AddRenewableEnergyPage() {
    return ( 
        <div className= "container-fluid">
            <AddEnergyBreadCrumb />
            <AddRenewableEnergy />
        </div>
     );
}

export default AddRenewableEnergyPage;